import { Map, List } from 'immutable'
import { handleActions } from 'redux-actions'
import { combineReducers } from 'redux-immutable'
import { getPresenceUserIds } from './helpers'
import {
  setFilters,
  setNewFilters,
  setShowMore,
  setNewSorts,
  setFilterKnownUsers,
  setPresenceIsReceiving,
  setPagination,
  setCustomInterval,
  setBufferedUsers,
  setNewLiveUsers,
  setProcessAllUsers,
  addUserProcessed,
  removeUserProcessedDelayed,
  sendActiveStatus,
  setPresenceProblems,
  setPresenceLoading,
  setHasProcessedUsers,
  messageSent,
} from './actions'
import {
  PresenceState,
  parsePresenceVisitor
} from './models'

const processAll = handleActions({
  [setProcessAllUsers]: (state, action) => {
    return action.payload
  },
}, false)

const usersProcessed = handleActions({
  [addUserProcessed]: (state, action) => {
    return state.withMutations((mutable) => {
      getPresenceUserIds(action.payload).forEach((presenceId) => {
        mutable.update(presenceId, 0, (count) => count + 1)
      })
    })
  },

  [removeUserProcessedDelayed]: (state, action) => {
    return state.withMutations((mutable) => {
      getPresenceUserIds(action.payload).forEach((presenceId) => {
        if (mutable.get(presenceId) === 1) {
          mutable.delete(presenceId)
        } else {
          mutable.update(presenceId, (count) => count - 1)
        }
      })
    })
  },
}, Map())

const data = handleActions({
  [setPresenceIsReceiving]: (state, action) => {
    const newState = state.set('toggle', action.payload.on)

    if (!action.payload.on) {
      // Buffered users is now stale
      return newState.delete('bufferedUsers')
    }

    return newState
  },

  [sendActiveStatus]: (state, action) => {
    return state.set('activeStatus', action.payload)
  },

  [setHasProcessedUsers]: (state, action) => {
    return state.set('hasProcessedUsers', true)
  },

  [setBufferedUsers]: (state, action) => {
    return state.set('bufferedUsers', action.payload)
  },

  [setNewLiveUsers]: (state, action) => {
    return state.withMutations(mutable => {
      mutable.set('newLiveUsers', List(action.payload.visitors.map(parsePresenceVisitor)))
      mutable.set('newLiveUsersCount', action.payload.resultSetSize)
    })
  },

  [setFilters]: (state, action) => {
    return state.set('filters', action.payload)
  },

  [setNewFilters]: (state, action) => {
    return state.set('newFilters', action.payload)
  },

  [setShowMore]: (state, action) => {
    return state.set('showMore', action.payload)
  },

  [setNewSorts]: (state, action) => {
    return state.set('newSorts', action.payload)
  },

  [setFilterKnownUsers]: (state, action) => {
    return state.set('filterKnownUsers', action.payload)
  },

  [setCustomInterval]: (state, action) => {
    return state.set('interval', action.payload)
  },

  [setPagination]: (state, action) => {
    return state.set('pagination', action.payload)
  },

  [setPresenceProblems]: (state) => {
    return state.set('presenceProblems', true)
  },

  [setPresenceLoading]: (state, action) => {
    return state.set('presenceLoading', action.payload)
  },

  [messageSent]: (state, action) => {
    return state.set('usersWithMessageSent', [...state.get('usersWithMessageSent'), action.payload])
  }
}, new PresenceState())

export default combineReducers({ data, processAll, usersProcessed })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/presence/reducer.js